module.exports = __webpack_public_path__ + "img/SELODE15ANOS-GEOTECH.669c60fb.png";